<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch01_part02"><a id="page_27"></a>PART II<br/><em>Savages of the Western Gulf Culture Area</em></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01_part02.vue?7a9e651d